<template>
  <div>

    <!-- PAQUETE PRINCIPAL -->
  
    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="HexagonIcon" class="mr-2 icon" />PAQUETE PRINCIPAL</span>
        </vs-col>
      </vs-row>

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosPrincipal" :key="'PRODUCTO_PRINCIPAL_'+index">
        <vs-row v-if="item.seccion==='PRODUCTO_PRINCIPAL'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
        </vs-row>
      </vx-card>        
    </vx-card>

    <!-- FIN PAQUETE PRINCIPAL -->

    <!-- PRIMER MOVIL ADICIONAL -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="SmartphoneIcon" class="mr-2 icon" />PRIMER MOVIL ADICIONAL</span>
        </vs-col>
      </vs-row>

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosPrimerMovilAdicional" :key="'PRIMER_MOVIL_ADICIONAL_'+index">
        <vs-row v-if="item.seccion==='PRIMER_MOVIL_ADICIONAL'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>
          
    <!-- FIN PRIMER MOVIL ADICIONAL -->

    <!-- MOVIL ADICIONAL -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="SmartphoneIcon" class="mr-2 icon" />MOVIL ADICIONAL</span>
        </vs-col>
      </vs-row> 

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosMovilAdicional" :key="'MOVIL_ADICIONAL_'+index">
        <vs-row v-if="item.seccion==='MOVIL_ADICIONAL'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>
    
    <!-- FIN MOVIL ADICIONAL -->

    <!-- TV -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="TvIcon" class="mr-2 icon" />TV</span>
        </vs-col>
      </vs-row>

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosTv" :key="'TV_'+index">
        <vs-row v-if="item.seccion==='TV'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>

    <!-- FIN TV -->

    <!-- SVA -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="WifiIcon" class="mr-2 icon" />SVA</span>
        </vs-col>
      </vs-row>

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosSva" :key="'VALOR_AÑADIDO_'+index">
        <vs-row v-if="item.seccion==='VALOR_AÑADIDO'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>

    <!-- FIN SVA -->

    <!-- SUMA TOTAL -->

    <vx-card slot="no-body" class="w-full mb-20 mt-16 fondoComentario" card-border>
      <vs-row>
        <vs-col vs-w="2"></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <span class="textoImporteTotalOperacionProducto">IMPORTE TOTAL: </span>    
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <span class="textoImporteTotalOperacionProducto">{{sumaImporteTotal}}€</span>
        </vs-col>
        <vs-col vs-w="2"></vs-col>
      </vs-row>
    </vx-card> 

    <!-- FIN SUMA TOTAL -->

  </div>
</template>

<script>
import commonComponentsStore from '@/store/common-components/index.js'
import productosStore from '@/store/gestion/productos/index.js'
import operacionesStore from '@/store/gestion/operaciones/index.js'
import vSelect from 'vue-select'

export default {
  name: 'operacionesEditProductos',
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      seccionPrincipal: 'PRODUCTO_PRINCIPAL',
      seccionPrimerMovilAdicional: 'PRIMER_MOVIL_ADICIONAL',
      seccionMovilAdicional: 'MOVIL_ADICIONAL',
      seccionSva: 'VALOR_AÑADIDO',
      seccionTv: 'TV',
      cliente: {},      
      productosContratados: [],
      codigoPrincipal: null,      
      productos: [], // productos del paquete_principal
      tipoProducto: null, // objeto para hacer la busqueda de los combos del paquete_principal            
      productoPrincipal: null, // objeto del producto_principal
      valProductos: [],
      primerMovilAdicional: {}, // objeto para hacer la busqueda de los combos del primer_movil_adicional
      sva: {},
      tv:{},
      movilAdicional: {},    
      disabledProductoPrincipal: false,
      disabledPrimerMovilAdicional: false,
      disabledMovilAdicional: false,
      disabledSva: false,
      disabledTv: false,
      habilitoComboPrimerMovilAdicional: false,
      habilitoComboMovilAdicional: false,
      habilitoComboSva: false,
      habilitoComboTv: false,
      borrado: false
    }
  },
  computed: {
    comboTipoProductosFiltrados () {
      const filtrado = []
      
      const filtered = this.valProductos.filter(el => el.seccion === this.seccionPrincipal)

      filtered.forEach(function (item) {
        const i = filtrado.findIndex(x => x.tipoProducto === item.tipoProducto)
        if (i <= -1) {          
          filtrado.push(item)
        }
      })       
      return filtrado
    },    
    comboProductosFiltrados () {
      const filtrado = []
      this.productos.forEach(function (item) {
        const i = filtrado.findIndex(x => x.producto === item.producto)
        if (i <= -1) {
          filtrado.push(item)
        }
      })
      filtrado.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })      
      return filtrado      
    },    
    comboPrimerMovilAdicionalFiltrado () {  
      // filtramos por los elementos que tengan el atributo asociados
      const listaPrimerMovilAdicional = this.valProductos.filter(el => el.seccion === this.seccionPrimerMovilAdicional)

      const filtrado = listaPrimerMovilAdicional.filter(function (el) {                
        return el.hasOwnProperty('asociados')
      })      

      // buscamos si el codigoPrincipal esta dentro del campo asociados      
      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }        
      }

      result.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })
      
      return result                     
    },
    comboMovilAdicionalFiltrado () {
      const listaMovilAdicional = this.valProductos.filter(el => el.seccion === this.seccionMovilAdicional)

      const filtrado = listaMovilAdicional.filter(function (el) {        
        return el.hasOwnProperty('asociados')
      })

      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }        
      }

      result.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })
      return result
    },
    comboSvaFiltrado () {    
      const listaSva = this.valProductos.filter(el => el.seccion === this.seccionSva)

      const filtrado = listaSva.filter(function (el) {        
        return el.hasOwnProperty('asociados')
      })

      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }       
      }
      listaSva.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })

      return listaSva
    },
    comboTvFiltrado () {
      const listaTv = this.valProductos.filter(el => el.seccion === this.seccionTv)

      const filtrado = listaTv.filter(function (el) {        
        return el.hasOwnProperty('asociados')
      })

      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }        
      }

      result.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })
      return result
    },
    codigoPrincipalFiltrado () { // tenemos que pillar el codigoPrincipal del PRODUCTO_PRINCIPAL
      let filtrado = this.productosContratados.filter(function (el) {        
        if (el.seccion === 'PRODUCTO_PRINCIPAL') {
          return el
        }
      })
      filtrado = filtrado[0].codigoPrincipal // devuelve un array con un elemento
      return filtrado
    },
    filtroProductosContratadosPrincipal () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'PRODUCTO_PRINCIPAL'        
      })      
      return filtrado
    },
    filtroProductosContratadosPrimerMovilAdicional () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'PRIMER_MOVIL_ADICIONAL'        
      })
      return filtrado
    },
    filtroProductosContratadosMovilAdicional () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'MOVIL_ADICIONAL'        
      })      
      return filtrado
    },
    filtroProductosContratadosSva () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'VALOR_AÑADIDO'        
      })
      return filtrado
    },
    filtroProductosContratadosTv () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'TV'        
      })
      return filtrado
    },
    sumaImporteTotal () {
      const filtrado = this.productosContratados.reduce((prev, cur) => {
        return prev + cur.importeConPromocion
      }, 0)
      return filtrado
    }
  },
  methods: {
    /* creo 2 funciones diferentes porque en el created no tengo el mismo objeto que despues*/
    esProductoUnico (tipoProducto) {
      let uni = null
      tipoProducto.unico === 'S' ? uni = true : uni = false      
      return uni
    },
    esProductoUnicoCreated (tipoProducto) {       
      let uni = null
      tipoProducto[0].productoTarjetas[0].unico === 'S' ? uni = true : uni = false      
      return uni
    }
  },
  async created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }    

    if (!productosStore.isRegistered) {
      this.$store.registerModule('productosStore', productosStore)
      productosStore.isRegistered = true
    }              

    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))     
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))  
    
    const busqueda = {}
    busqueda.operador    = this.$store.state.operacionesStore.operacion.operador
    busqueda.tipoCliente = this.$store.state.operacionesStore.operacion.tipoCliente

    await this.$store.dispatch('commonComponentsStore/getValProductosByOperadorCliente', busqueda)
      .then(() => {
        this.valProductos   = JSON.parse(JSON.stringify(this.$store.state.commonComponentsStore.valProductos))
      })

    if (this.operacion.productos.length > 0) {
      
      this.disabledProductoPrincipal  = true
      this.habilitoComboSva           = true
      this.habilitoComboTv            = true
      this.productosContratados       = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos))
      this.codigoPrincipal            = this.codigoPrincipalFiltrado
      
      this.primerMovilAdicional = this.movilAdicional = this.sva = this.tv = null
      this.tipoProducto         = this.productoPrincipal = this.filtroProductosContratadosPrincipal      
      this.primerMovilAdicional = this.filtroProductosContratadosPrimerMovilAdicional
      this.movilAdicional       = this.filtroProductosContratadosMovilAdicional
      this.tv                   = this.filtroProductosContratadosTv
      
      this.productoPrincipal.length > 0 ? this.habilitoComboPrimerMovilAdicional = true : this.habilitoComboPrimerMovilAdicional = false    
      this.primerMovilAdicional.length > 0 ? this.habilitoComboMovilAdicional = true : this.habilitoComboMovilAdicional = false

      if (this.primerMovilAdicional.length > 0) {
        this.esProductoUnicoCreated(this.primerMovilAdicional) ? this.disabledPrimerMovilAdicional = true : this.disabledPrimerMovilAdicional = false
      }

      if (this.movilAdicional.length > 0) {        
        this.esProductoUnicoCreated(this.movilAdicional) ? this.disabledMovilAdicional = true : this.disabledMovilAdicional = false
        this.movilAdicional = null
      } else {
        this.disabledMovilAdicional = false
      }

      if (this.tv.length > 0) {
        this.esProductoUnicoCreated(this.tv) ? this.disabledTv = true : this.disabledTv = false
      }
    }
                  
  },
  mounted () {
    this.isMounted = true        
  }
}
</script>
